import { zodResolver } from '@hookform/resolvers/zod';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';

import Button from '@/components/BaseLibrary/Button/Button';
import FormInput, {
  InputType,
} from '@/components/BaseLibrary/FormInput/FormInput';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { trackEvents } from '@/utils/analytics';
import {
  firstNameValidator,
  InputName,
  lastNameValidator,
} from '@/utils/validation/inputs';

interface EmailStepProps {
  handleNext: (data: SchemaType) => void;
}

const schema = z.object({
  ...firstNameValidator,
  ...lastNameValidator,
});
type SchemaType = z.infer<typeof schema>;

export default function EmailStep({ handleNext }: EmailStepProps) {
  const { classes } = useStyles();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<SchemaType>({
    resolver: zodResolver(schema),
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<SchemaType> = (data: SchemaType) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Name',
      Form_step: 5,
      click_text: 'Next',
    });
    handleNext(data);
  };

  return (
    <>
      <FormInput
        placeholder='Enter your First Name'
        name={InputName.FIRST_NAME}
        testId='first-name-input'
        type={InputType.TEXT}
        inputMode='text'
        error={errors[InputName.FIRST_NAME]?.message}
        register={register}
      />
      <FormInput
        placeholder='Enter your Last Name'
        name={InputName.LAST_NAME}
        testId='last-name-input'
        type={InputType.TEXT}
        inputMode='text'
        error={errors[InputName.LAST_NAME]?.message}
        register={register}
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={handleSubmit(onSubmit)}
          label='Next'
          disabled={!isValid}
          className={classes.button}
        />
      </div>
    </>
  );
}
